import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
export const questionFormType = function () {
  let obj = {
    QUESTIONNAIRE: "QUESTIONNAIRE",
    ANSWER: "ANSWER"
  };
  obj.selectOptionList = [{
    label: "问卷",
    value: obj["QUESTIONNAIRE"]
  }, {
    label: "答题",
    value: obj["ANSWER"]
  }];
  obj.getLabel = key => {
    const data = obj.selectOptionList.find(item => item.value == key);
    if (data) {
      return data.label;
    }
    return key;
  };
  return obj;
}();
export const questionTopicType = function () {
  let obj = {
    SINGLE_CHOICE: "SINGLE_CHOICE",
    MULTIPLE_CHOICE: "MULTIPLE_CHOICE",
    BLANKS: "BLANKS",
    UPLOAD: "UPLOAD"
  };
  obj.selectOptionList = [{
    label: "单选题",
    value: obj["SINGLE_CHOICE"]
  }, {
    label: "多选题",
    value: obj["MULTIPLE_CHOICE"]
  }, {
    label: "填空题",
    value: obj["BLANKS"]
  }, {
    label: "上传附件题",
    value: obj["UPLOAD"]
  }];
  obj.getLabel = key => {
    const data = obj.selectOptionList.find(item => item.value == key);
    if (data) {
      return data.label;
    }
    return key;
  };
  return obj;
}();
export const questionScoreRule = function () {
  let obj = {
    SAME: "SAME",
    INCLUDE: "INCLUDE"
  };
  obj.selectOptionList = [{
    label: "回答与答案完全一致才得分",
    value: obj["SAME"]
  }, {
    label: "回答中包含答案即可得分",
    value: obj["INCLUDE"]
  }];
  obj.getLabel = key => {
    const data = obj.selectOptionList.find(item => item.value == key);
    if (data) {
      return data.label;
    }
    return key;
  };
  return obj;
}();